import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Directions } from '../../../../../core/src/lib/enums/direction.enum';

declare const $localize;

@Component({
  selector: 'portal-search-filter-autocomplete-input',
  templateUrl: './search-autocomplete-input.component.html',
  standalone: false,
})
export class FilterAutoCompleteInputComponent {
  @Input() placeholder = $localize`:placeholder|Search input placeholder:Search`;
  @Input() id: string;
  @Input() direction: Directions = Directions.LEFT;
  @Input() searchInputValue: string = '';
  @Output() search: EventEmitter<string> = new EventEmitter();
  @ViewChild('searchRef') searchRef!: ElementRef;

  placeholderText = $localize`:placeholder|Search input placeholder:Search`;

  readonly directions = Directions;
  constructor() {}

  onSearch(searchValue: string): void {
    this.search.emit(searchValue);
  }

  reset(): void {
    this.searchInputValue = '';
    if (this.searchRef?.nativeElement) {
      this.searchRef.nativeElement.value = '';
    }
    this.search.emit('');
  }
}
